// extracted by mini-css-extract-plugin
export default {"badge":"badge--iHsJc","icon":"icon--EK6rX","aiBadgeTooltip":"aiBadgeTooltip--IuSri"};